// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__6mVgj","logo":"MainNavigation_logo__WuOUh","nav":"MainNavigation_nav__1WwUt","active":"MainNavigation_active__wnNSU"};